import type { Participant } from '@seen/core/models/patients/participant'
import { useContext } from 'react'
import { CurrentParticipantContext } from '#src/contexts/current-participant/CurrentParticipantContext.tsx'

export const useCurrentParticipant = (): Participant => {
  const context = useContext(CurrentParticipantContext)
  if (context === null) {
    throw new Error(
      'useCurrentParticipant must be used within a CurrentParticipantProvider'
    )
  }
  return context
}
